var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudErroricon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M42.1672 34.8809C44.712 32.7793 46.3339 29.5999 46.3339 26.0417C46.3339 19.7134 41.2038 14.5833 34.8756 14.5833C34.4203 14.5833 33.9944 14.3458 33.7633 13.9536C31.0465 9.34341 26.0306 6.25 20.2922 6.25C11.6628 6.25 4.66724 13.2456 4.66724 21.875C4.66724 26.1794 6.40775 30.0772 9.22338 32.9032",
    stroke: "#F26648",
    strokeWidth: 4.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    d: "M20.2922 29.6726L30.7089 40.0893M30.7089 29.6726L20.2922 40.0893",
    stroke: "#F26648",
    strokeWidth: 4.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudErroricon);
export default __webpack_public_path__ + "static/media/cloud--error.icon.27d54afb9747dc8c8b5760005ac55dd8.svg";
export { ForwardRef as ReactComponent };